import {jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'
import StyledLink from './StyledLink'





const InlineCopy = styled(InvitationDialogCopy)({
  display: 'inline-block'
})

const TeamInvitationErrorAccepted = (props) => {
  const {verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationErrorAccepted_verifiedInvitation on VerifiedInvitationPayload {
        meetingId
        meetingName
        teamName
        teamInvitation {
          teamId
        }
      }
    `,
    verifiedInvitationRef
  )
  const {meetingId, meetingName, teamInvitation, teamName} = verifiedInvitation
  useDocumentTitle(`Token already accepted | Team Invitation`, 'Team Invitation')
  if (!teamInvitation || teamName === null) return null
  const {teamId} = teamInvitation
  return (
    _jsxs(InviteDialog, { children: [
      _jsx(DialogTitle, { children: "Invitation Already Accepted"  })
      , _jsxs(DialogContent, { children: [
        _jsxs(InvitationDialogCopy, { children: ["The invitation to "
             , teamName, " has already been redeemed."
        ]})
        , meetingName ? (
          _jsxs(_Fragment, { children: [
            _jsxs(StyledLink, { to: `/meet/${meetingId}`, title: `Join ${meetingName}`, children: ["Join "
               , meetingName
            ]}), ' '
            , _jsx(InlineCopy, { children: "in progress…" })
          ]})
        ) : (
          _jsxs(_Fragment, { children: [
            _jsx(InlineCopy, { children: "Visit the" }), ' '
            , _jsx(StyledLink, { to: `/team/${teamId}`, title: "Visit the Team Dashboard"   , children: "Team Dashboard"

            })
          ]})
        )
      ]})
    ]})
  )
}

export default TeamInvitationErrorAccepted
